
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mdiPlus, mdiArrowUp, mdiArrowDown } from '@mdi/js';
import { AthleteMetric, AthleteMetricValues } from '../../types/enums';
import * as Routes from '../../types/constants/web_client_user.routes';
import Page from './Page.vue';
import AthleteVerifiedAssessmentsCard from '../components/profile/athlete/AthleteVerifiedAssessmentsCard.vue';
import AthleteStatCard from '../components/profile/athlete/AthleteStatCard.vue';
import ComingSoonCard from '../components/ui/ComingSoonCard.vue'
import EditOverlay from '../components/ui/EditOverlay.vue'
import JerseySvg from '../components/svg/JerseySvg.vue'
import ImageUploadDialog from '../components/profile/ImageUploadDialog.vue'
import StatsSummaryCard from '../components/profile/athlete/StatsSummaryCard.vue'
import { VuetifyMixin, AuthMixin } from '../mixins';
import {athleteProfile} from '../store';
import RadarChartSvg from '../components/svg/RadarChartSvg.vue'
import MetricSvg from '../components/svg/MetricSvg.vue'
import TacticalClipboardSvg from '../components/svg/TacticalClipboardSvg.vue'
import VideoClipSvg from '../components/svg/VideoClipSvg.vue'
import GraduateCapSvg from '../components/svg/GraduateCapSvg.vue'
import AthleteSpqReportCard from '../components/profile/athlete/AthleteSpqReportCard.vue';
import AssessmentDataInfoProvider from '../components/hoc/AssessmentDataInfoProvider.vue';
import { formatDateMonthDay } from '../helpers';
import { formatNumber } from '../pipes/formatNumber.pipe';
import { AthleteAssessmentDataModel } from '../models/athlete/AthleteAssessmentDataModel';

@Component({
	components:{
		AthleteVerifiedAssessmentsCard,
		AthleteStatCard,
		AssessmentDataInfoProvider,
		AthleteSpqReportCard,
		ComingSoonCard,
		EditOverlay,
		StatsSummaryCard,
		ImageUploadDialog,
		Page,
		JerseySvg,
		RadarChartSvg,
		MetricSvg,
		TacticalClipboardSvg,
		VideoClipSvg,
		GraduateCapSvg,
	},
	async beforeRouteEnter(to, _, next){
		next((vm: AthleteVerifiedAssessmentSummary) => {
			if(vm.athleteId !== null){
				athleteProfile.getAthleteProfile(vm.athleteId);
				athleteProfile.loadVerifiedAssessments({athleteId: vm.athleteId});
			}else{
				athleteProfile.getAthleteProfile(vm.$auth.athleteId);
				athleteProfile.loadVerifiedAssessments({athleteId: vm.$auth.athleteId});
			}
		});
	},
	async beforeRouteUpdate(_, __, next){
		if(this.athleteId !== null){
			athleteProfile.getAthleteProfile(this.athleteId);
			athleteProfile.loadVerifiedAssessments({athleteId: this.athleteId});
		}else{
			athleteProfile.getAthleteProfile(this.$auth.athleteId);
			athleteProfile.loadVerifiedAssessments({athleteId: this.$auth.athleteId});
		}
		next();
	},
})
export default class AthleteVerifiedAssessmentSummary extends Mixins(AuthMixin, VuetifyMixin){
	mdiPlus = mdiPlus;
	mdiArrowUp = mdiArrowUp;
	mdiArrowDown = mdiArrowDown;
	formatDateMonthDay = formatDateMonthDay;
	formatNumber = formatNumber;
	@Prop({ default: null }) athleteId: string | null;

	private addAssessment(){
		this.$router.push({
			name: Routes.AthleteClaimAssessmentForm,
			params:{
				...this.$route.params,
			}
		});
	}

	get Loading(): boolean{
		return athleteProfile.IsLoading || athleteProfile.verifiedAssessmentsLoading;
	}
	get AthleteMetrics(): AthleteMetric[]{
		return AthleteMetricValues;
	}
	get FirstAssessment(): AthleteAssessmentDataModel{
		return this.VerifiedAssessments[0];
	}
	get VerifiedAssessments(): AthleteAssessmentDataModel[]{
		return athleteProfile.verifiedAssessments.slice().sort((a,b) => {
			return +b.assessmentDate - +a.assessmentDate;
		});
	}
	get Acceleration(): AthleteMetric.Acceleration{ return AthleteMetric.Acceleration; }
	get Speed(): AthleteMetric.Speed{ return AthleteMetric.Speed; }
	get Power(): AthleteMetric.Power{ return AthleteMetric.Power; }
	get Agility(): AthleteMetric.Agility{ return AthleteMetric.Agility; }
	get Recovery(): AthleteMetric.Recovery{ return AthleteMetric.Recovery; }

	private goToMetric(metric: AthleteMetric){
		this.$router.push({
			name: Routes.AthleteComparativeDataSummary,
			params:{
				...this.$route.params,
				metric
			}
		});
	}
}
